import React from 'react';
import { Facebook, Twitter, Instagram, Send, MessageCircle } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#020202] pt-20 pb-10 border-t border-[#c9a96e]/10" data-id="element-81">
      <div className="max-w-7xl mx-auto px-6" data-id="element-82">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-83">
          {/* Brand */}
          <div data-id="element-84">
            <div className="flex items-center gap-2 mb-6" data-id="element-85">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#c9a96e] to-[#8a7035] flex items-center justify-center text-black font-serif font-bold text-lg" data-id="element-86">
                S
              </div>
              <span className="text-2xl font-serif font-bold text-white tracking-wide" data-id="element-87">
                后宫 <span className="text-[#c9a96e]" data-id="element-88">SGHarem</span>
              </span>
            </div>
            <p className="text-neutral-500 text-sm leading-relaxed mb-6" data-id="element-89">
              Singapore's premier directory for high-class companions, escorts,
              and massage services. Defining luxury and discretion.
            </p>
            <div className="flex gap-4" data-id="element-90">
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-91">
                <Twitter size={18} data-id="element-92" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-93">
                <Instagram size={18} data-id="element-94" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-[#111111] border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-[#c9a96e] hover:border-[#c9a96e] transition-all" data-id="element-95">
                <Send size={18} data-id="element-96" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-97">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-98">Quick Links</h4>
            <ul className="space-y-3" data-id="element-99">
              {['Home', 'Featured Companions', 'Services', 'Membership', 'Contact Us'].map(item => <li key={item} data-id="element-100">
                  <a href="#" className="text-neutral-500 hover:text-[#c9a96e] transition-colors text-sm" data-id="element-101">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Areas Served */}
          <div data-id="element-102">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-103">Areas Served</h4>
            <ul className="space-y-3" data-id="element-104">
              {['Orchard Road', 'Marina Bay Sands', 'Sentosa Cove', 'Clarke Quay', 'Bugis', 'Tanjong Pagar'].map(item => <li key={item} data-id="element-105">
                  <a href="#" className="text-neutral-500 hover:text-[#c9a96e] transition-colors text-sm" data-id="element-106">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-107">
            <h4 className="text-white font-serif text-lg mb-6" data-id="element-108">Contact Us</h4>
            <div className="space-y-4" data-id="element-109">
              <div className="flex items-center gap-3 text-neutral-400" data-id="element-110">
                <MessageCircle size={18} className="text-[#c9a96e]" data-id="element-111" />
                <span className="text-sm" data-id="element-112">WeChat: SGHarem_Official</span>
              </div>
              <div className="flex items-center gap-3 text-neutral-400" data-id="element-113">
                <Send size={18} className="text-[#c9a96e]" data-id="element-114" />
                <span className="text-sm" data-id="element-115">Telegram: @SGHarem_SG</span>
              </div>
              <div className="p-4 bg-[#111111] border border-neutral-800 rounded-lg mt-4" data-id="element-116">
                <p className="text-xs text-neutral-500 text-center" data-id="element-117">
                  For advertising inquiries, please contact our support team via
                  Telegram.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 友站链接 Partner Links */}
        <div className="border-t border-neutral-900 pt-8 pb-8 mb-8" data-id="element-118">
          <h4 className="text-white font-serif text-sm mb-4 text-center uppercase tracking-widest" data-id="element-119">
            友站链接 <span className="text-[#c9a96e]" data-id="element-120">Partner Sites</span>
          </h4>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-121">
            {[{
            name: 'TTvip',
            url: 'https://www.TTvip-64.com'
          }, {
            name: 'Shiok27',
            url: 'https://www.shiok27.com/'
          }, {
            name: 'XFY01',
            url: 'https://www.xfy01.net/'
          }, {
            name: 'SGHarem6',
            url: 'https://www.sgharem6.net/'
          }, {
            name: 'QC52',
            url: 'https://www.qc52.me'
          }, {
            name: 'SGLonelyGuy',
            url: 'https://sglonelyguy.me'
          }, {
            name: 'TTvip Life',
            url: 'https://ttvip.life'
          }, {
            name: 'Locanto',
            url: 'https://locanto.space'
          }, {
            name: 'KKBaby',
            url: 'https://kkbaby.site'
          }, {
            name: 'XFY8',
            url: 'https://xfy8.com'
          }, {
            name: 'SG Beauty Castle',
            url: 'https://sgbeautycastle.live'
          }, {
            name: 'Shiok26',
            url: 'https://shiok26.site'
          }, {
            name: 'SGHarem',
            url: 'https://sgharem.site'
          }, {
            name: 'Shiok8',
            url: 'https://shiok8.xyz'
          }, {
            name: 'Geylang777',
            url: 'https://geylang777.info'
          }, {
            name: 'TTvip-62',
            url: 'https://ttvip-62.site'
          }, {
            name: 'Geylang666',
            url: 'https://geylang666.me'
          }, {
            name: 'IsYou',
            url: 'https://isyou.net'
          }].map(site => <a key={site.name} href={site.url} target="_blank" rel="noopener noreferrer" className="px-4 py-2 bg-[#111111] border border-neutral-800 rounded-lg text-neutral-400 text-xs hover:text-[#c9a96e] hover:border-[#c9a96e]/50 transition-all duration-300" data-id="element-122">
                {site.name}
              </a>)}
          </div>
        </div>

        <div className="border-t border-neutral-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-123">
          <p className="text-neutral-600 text-xs" data-id="element-124">
            © 2024 SGHarem. All rights reserved.
          </p>
          <div className="flex items-center gap-2 px-3 py-1 bg-[#1a1a1a] rounded border border-neutral-800" data-id="element-125">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-126" />
            <span className="text-neutral-400 text-xs font-medium" data-id="element-127">
              Adults Only 18+
            </span>
          </div>
        </div>
      </div>
    </footer>;
}